export { PlayerBar } from './component'
